// extracted by mini-css-extract-plugin
module.exports = {"promoExpireDate":"az_Jwc"};